import { Injectable } from '@angular/core';
import { IConfig, IServer } from '../interfaces/config';
import { environment } from 'src/environments/environment';
import { IError } from 'projects/common/src/app/interfaces';
import { ModuleConfigService } from 'projects/common/src/app/services';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends ModuleConfigService<IConfig> {

  constructor() {
    super();
    // TODO: cargar config desde servidor
    this.config = {
      showVersion: true,
      layout: {
        navbar: {
          visibility: true,
        },
        footer: {
          visibility: false,
        }
      },
      servers: [
        {
          name: 'default',
          host: environment.serverHost,
          port: environment.serverPort,
        },
        {
          name: 'socket',
          host: environment.serverHost,
          port: environment.serverSocketPort,
        }
      ],
      modules: [
        {
          name: 'app',
          requiredParameters: [
            'language',
            'language-collection',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'dsh',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'login',
          requiredParameters: [
            'language',
            'language-collection',
            'screen-media',
            'date'
          ]
        },
        {
          name: 'map',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
            'user-data'
          ]
        },
        {
          name: 'secondary-breaking',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
            'user-data'
          ]
        },
        {
          name: 'messenger',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'report',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'summary',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'front',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'files',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'update-app',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
          ]
        },
        {
          name: 'admin',
          requiredParameters: [
            'language',
            'language-collection',
            'date',
            'screen-media',
            'session',
            'permission'
          ]
        }
      ]
    };
  }

  public getConfig(): IConfig {
    return this.config;
  }

  public serverUrl(name: string, path?: string): string {
    if (typeof name === 'string') {
      const found = this.config.servers.find((server: IServer) => name === server.name);
      if (found) {
        return `http://${found.host}:${found.port}${path ? '/' + path : ''}`;
      } else {
        this.error(`invalid_url [${name}]`);
      }
    } else {
      throw {
        message: 'invalid_value_provided'
      } as IError;
    }
    return null;
  }

  /**
   * Retorna un arreglo con los nombres de los parámetros que son requeridos
   * para el funcionamiento del modulo dado en el argumento.
   * Si la configuración no existe retorna null.
   * @param moduleName nombre del módulo del cual se requiere obtener los
   * parámetros necesarios para su funcionamiento
   */
  public requiredParameterForModule(moduleName: string): string[] {
    if (typeof moduleName === 'string') {
      // TODO Obtener configuración desde datos dados por api al logearse
      const module = this.config.modules.find(x => x.name.toLowerCase() === moduleName.toLowerCase());
      if (module && Array.isArray(module.requiredParameters)) {
        return module.requiredParameters;
      }
    }
    return null;
  }

}
